export default __webpack_public_path__ + "assets/models/0edc40b9ee5436e48b15fd8ba8df1025.glb";